import React from 'react'

function UserEstimatesPage() {
  return (
    <div>UserEstimatesPage</div>
  )
}

export default UserEstimatesPage